var map = {
	"./1.svg": 70616,
	"./2.svg": 80197,
	"./3.svg": 88457,
	"./4.svg": 74719,
	"./5.svg": 59955,
	"./6.svg": 36503,
	"./7.svg": 51294,
	"./8.svg": 9753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343;